import { Grid } from "@mui/material"
import { BoxCard } from "../../basics/BoxCard"
import { IClientsOverviewCardProps } from "./types"
import { InnerSection } from "../InnerSection"
import intl from "src/internationalization/intl"

const ClientsOverviewCard = (props: IClientsOverviewCardProps) => {
    return (
        <BoxCard>
            <Grid container gap={2} alignItems="center">
                <Grid item>
                    <InnerSection title={intl("clientsTotal")} text={props.numberOfClients.toString()} />
                </Grid>
                <Grid item>
                    <InnerSection title={intl("volumeUnderCustody")} text={props.totalAmount.toString()} />
                </Grid>
            </Grid>
        </BoxCard>
    )
}

export { ClientsOverviewCard };